<template>
    <div class="w-full flex flex-column gap-5 mb-5
        px-0 xl:px-3 lg:px-3 md:px-3
        surface-0 xl:surface-100 lg:surface-100 md:surface-100">

        <!--WALLET-->
        <WalletWidget v-if="wallet" @refresh="refresh"
            :title="getWalletNameByType(wallet.ext_type, lang)"
            :balance="wallet.balance" 
            :currency="'usdt'" 
            :wallets="wallets"
            :wallet_id="wallet.id" 
            :wallet_type="wallet.ext_type"
            :deposit_wallet_id="depositWalletId"
            :loading="loading" 
            :btnWithdraw="false"
            />

        <div class="w-full flex gap-5 mb-3
            px-3 xl:px-0 lg:px-0 md:px-0
            flex-column xl:flex-row lg:flex-row md:flex-row">

            <!--Cards-->
            <div class="w-full flex flex-column">
                <div class="w-full hidden flex-row mb-3 xl:flex lg:flex md:flex">
                    <div class="flex flex-1 align-items-center">
                        <span class="text-xl font-medium text-900 h-2rem">{{ content[lang].cardsTitle }}</span>
                    </div>
                    <div class="flex">

                    </div>
                </div>
                <div class="w-full flex flex-1 mb-5
                    p-0 xl:p-3 lg:p-3 md:p-2
                    flex-column 
                    align-items-center
                    xl:border-round-3xl lg:border-round-2xl md:border-round-xl
                    xl:surface-0 lg:surface-0 md:surface-0
                    text-center relative gap-5">

                    <SelectButton v-model="active_index" :options="tabs1" optionLabel="label" optionValue="index" dataKey="title" size="small" class="mt-2 ">
                        <template #option="slotProps">
                            <span class="text-sm py-1 white-space-nowrap">{{ slotProps.option.label[lang] }}</span>
                        </template>
                    </SelectButton>

                    <div v-if="active_index==0" class="w-full flex flex-column gap-3">
                        <div v-if="cardData && cardData.cards" class="w-full flex flex-column gap-3">
                            <CardList v-if="cardData.cards && cardData.cards.length>0" :loading="loading" :cards="cards" />
                            <Message v-else severity="info" class="border-round-xl max-w-30rem" icon="pi pi-info-circle">
                                <span class="line-height-2 text-sm xl:text-md lg:text-sm">{{ content[lang].no_cards }}</span>
                            </Message>
                        </div>
                        <div v-else class="w-full">
                            <Skeleton height="4rem" class="my-3" /> 
                        </div>
                    </div>

                    <div v-if="active_index==1" class="w-full flex flex-column">
                        <div class="w-full flex flex-column gap-3">
                            <div v-if="cardData && cardData.cards" class="w-full flex flex-column gap-3">
                                <CardListRaw :balance="(wallet && wallet.balance) ? wallet.balance: 0"/>
                            </div>
                            <div v-else class="w-full">
                                <Skeleton height="4rem" class="my-3" /> 
                            </div>
                        </div>
                        <!-- <Message v-else severity="info" class="border-round-xl" icon="pi pi-info-circle">
                            <span class="line-height-2 text-sm xl:text-md lg:text-sm">Мы обновляем этот раздел, скоро здесь появятся новые карты.</span>
                        </Message> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--FAQ-->
    <div class="w-full px-3 mb-5">
        <div class="w-full flex flex-column xl:w-6 lg:w-6">
            <div class="w-full flex flex-row mb-3">
                <div class="flex flex-1 align-items-center">
                    <span class="text-xl font-medium text-900 h-2rem">{{ content[lang].faqTitle }}</span>
                </div>
                <div class="flex">
                    <Button :label="content[lang].btnFaq" @click="toFaq()" size="small" severity="secondary"
                        class="flex surface-0 text-xs" icon="pi pi-arrow-right" iconPos="right" rounded />
                </div>
            </div>
            <div class="w-full flex">
                <FaqShortList v-if="tabs" :tabs="tabs" :count="3" />
            </div>
        </div>
    </div>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue' 
import WalletWidget from    '@/components/personal/wallet/WalletWidget.vue'
import CardList from        '@/components/personal/vcard/List.vue' 
import CardListRaw from     '@/components/personal/vcard/ListRaw.vue' 
import FaqShortList from    '@/components/widgets/FaqList.vue'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                en: { title: 'My cards' },
                ru: { title: 'Мои карты' }
            },
            content: {
                ru: {
                    issueBtn: 'Выпустить',
                    topupBtn: 'Пополнить',
                    walletBtn: 'Обменять',
                    noaccess: 'У вас нет доступа к картам',
                    cardsTitle: 'Карты',
                    popupIssueTitle: 'Выберите карту',
                    popupTopupTile: 'Пополнить счет',
                    popupTopupBtn: 'Пополнить',
                    faqTitle: "FAQ",
                    faqBtn: "Все ответы",
                    beginBtn: 'Подключить',
                    success: 'Успешно',
                    successCreate: 'Карта успешно создана',
                    successWallet: 'Кошелек успешно создан',
                    error: 'Ошибка',
                    errorCreate: 'Ошибка создания карты',
                    no_cards: 'У вас еще нет активных карт',
                    btnFaq: 'Подробно',
                },
                en: {
                    issueBtn: 'Issue',
                    topupBtn: 'Top up',
                    walletBtn: 'Exchange',
                    noaccess: 'You have no access to cards',
                    cardsTitle: 'Cards',
                    popupIssueTitle: 'Choose card',
                    popupTopupTile: 'Top up card',
                    popupTopupBtn: 'Top up',
                    faqTitle: "FAQ",
                    faqBtn: "All answers",
                    beginBtn: 'Connect',
                    success: 'Success',
                    successCreate: 'Card successfully created',
                    successWallet: 'Wallet successfully created',
                    error: 'Error',
                    errorCreate: 'Error creating card',
                    no_cards: 'You have no active cards yet',
                    btnFaq: 'Details',
                }
            },
            tabs: [
                {
                    ru: {
                        title: "Как выпустить карту?",
                        content: "Откройте Все карты, выберите нужную карту и нажмите кнопку Выпустить. После этого карта будет создана и появится в разделе Мои карты. Если кнопка выпустить не активная, значит у вас недостаточно средств на кошельке для выпуска карты. Пополните кошелек и попробуйте снова."
                    },
                    en: {
                        title: "How to issue a card?",
                        content: "Open All cards, select the desired card and click the Issue button. After that, the card will be created and will appear in the My cards section. If the issue button is inactive, it means you do not have enough funds in your wallet to issue a card. Top up your wallet and try again."
                    }
                },
                {
                    ru: {
                        title: "Как пополнить карту?",
                        content: "Для начала нужно пополнить кошелек, а именно Карточный счет (счетов может быть несколько). После этого можно пополнить карту с этого счета."
                    },
                    en: {
                        title: "How to top up a card?",
                        content: "First you need to top up your wallet, namely the Card account (there may be several accounts). After that, you can top up the card from this account."
                    }
                },
                {
                    ru: {
                        title: "Какие есть комиссии?",
                        content: "Для каждого типа карты существуют свои комиссии. Подробнее о комиссиях можно узнать в описании каждой карты."
                    },
                    en: {
                        title: "What are the fees?",
                        content: "Each type of card has its own fees. More details about the fees can be found in the description of each card."
                    }
                }
            ],
            active_index: 0,
            tabs1: [
                {
                    "label": {
                        "en": "My cards",
                        "ru": "Мои карты"
                    },
                    "codes": null,
                    "disabled": false,
                    "index": 0
                },
                {
                    "label": {
                        "en": "All cards",
                        "ru": "Все карты",
                    },
                    "codes": ["card", "stock", "sbp", "swift"],
                    "disabled": false,
                    "index": 1
                },
            ],
            loading: false,
            cardData: null,

            variants: {
                1: {
                    ru: {
                        title: 'Classic Green',
                        brand: 'VISA/MasterCard',
                        description: 'Подходит для оплаты онлайн сервисов. Не используется в Apple Pay и Google Pay. Комиссия за выпуск 1$. Комиссия за транзакцию 0.25%',
                        vendor_id: 'squarefi_program_1'
                    },
                    en: {
                        title: 'Classic Green',
                        brand: 'VISA/MasterCard',
                        description: 'Suitable for paying for online services. Not used in Apple Pay and Google Pay. Issue fee 1$. Transaction fee 0.25%',
                        vendor_id: 'squarefi_program_1'
                    }
                },
                2: {
                    ru: {
                        title: 'Extended Virtual',
                        brand: 'VISA/MasterCard',
                        description: 'Для оплаты онлайн-сервисов, авиабилетов и повседневных расходов в магазинах (например: Amazon, Google). Можно добавить карту в ApplePay или PayPal. Комиссия за выпуск 1$. Комиссия за транзакцию 0.25%',
                        vendor_id: 'squarefi_program_2'
                    },
                    en: {
                        title: 'Extended Virtual',
                        brand: 'VISA/MasterCard',
                        description: 'For paying for online services, airline tickets and everyday expenses in stores (for example: Amazon, Google). You can add the card to ApplePay or PayPal. Issue fee 1$. Transaction fee 0.25%',
                        vendor_id: 'squarefi_program_2'
                    }
                }
            },
            step: 0,
            choosed: null,
            fullname: null,
            cards: [],
            sendClick: false,
            wallet: null,
            wallet_id: null,
            isIssue: false,
            isTopup: true,
        }
    },
    components: {
        Page,
        CardList,
        CardListRaw,
        WalletWidget,
        FaqShortList
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        depositWalletId() { return this.getDepositWalletId(this.$store.getters.StateWallets)},
        wallets() { return this.$store.getters.StateWallets },
    },
    watch: {
        wallets: {
            handler(list) {
                if(!list || !Array.isArray(list)) return
                this.wallet = list.find(wallet => wallet.ext_type === 'vcard')
            },
            immediate: true
        },
        active_index: {
            handler(index) {
                if(index==undefined) {
                    this.active_index = 0
                }
            },
            immediate: true
        },
    },
    methods: {
        ...mapActions(['ActionGetWalletByType']),
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        getWalletNameByType(type) {
            return this.helper.getWalletNameByType(type, this.lang)
        },
        getDepositWalletId(list) {
            if(!list || !Array.isArray(list)) return null
            if(list && list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                    if(list[i].type == 'deposit') return list[i].id
                }
            } else return null
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        toFaq() {
            // this.$router.push({ path: '/support/faq/' })
            window.open('https://ok.pay-wave.co/virtual-cards', '_blank')
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency, 1)
        },
        async getCards(){
            this.loading = true
            try {
                const cardData = await this.connect.GetUserCards().then(res=>res)
                if(cardData.result) {
                    this.cardData = cardData.data
                    this.cards = cardData.data.cards
                    if(this.cardData.wallet_id) this.wallet_id = this.cardData.wallet_id
                    if(this.cards && this.cards.length > 0) {
                        this.active_index = 0
                    } else {
                        this.active_index = 1
                    }
                } else {
                    this.cardData = null
                    this.active_index = 1
                }
            } catch (error) {
                console.log(error)
            }
            this.loading = false
        },
        async be(){
            try{
                const be = await this.connect.CreateCardWallet().then(res=>res)
                if(be.result){
                    this.showMess('success', this.content[this.lang].success, this.content[this.lang].successWallet)
                    this.wallet_id = be.data.wallet_id
                }else {
                    if(be.errors) this.showMess('error', this.content[this.lang].error, be.errors[0])
                    else this.showMess('error', this.content[this.lang].error, this.content[this.lang].errorCreate)
                }
            } catch (error) {
                console.log(error)
            }
        },
        async refresh(){
            this.loading = true
            try { await this.ActionGetWalletByType('vcard').then(res=>res) } 
            catch (error) { console.log(error) }
            this.loading = false
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.getCards().then(res=>res)
    }
}
</script>